const PlatformContent = () => {
  return null;
};

export default PlatformContent;
